import Vue from 'vue'
import VueRouter from 'vue-router'
import Result from './Result.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Result,
    },
];

const router = new VueRouter({
    routes
})

router.beforeEach(async (to, from, next) => {
    to.query.q ??= "";
    to.query.p ??= 1;
    next();
})

export default router
